import { createReducer, on } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import { DestroyAction } from './destroy.actions';
import {
  DestroyListContent,
  DestroyRequestListContent,
  DestroyRequestViewResponse,
  DestroyViewResponse
} from '../model/destroy-model';

export const destroyKey = 'destroy';

export interface DestroyState {
  destroyRequestList: Pagination<DestroyRequestListContent>;
  destroyRequestView: DestroyRequestViewResponse;
  destroyList: Pagination<DestroyListContent>;
  destroyView: DestroyViewResponse;
}

export const initialState: DestroyState = {
  destroyRequestList: null,
  destroyRequestView: null,
  destroyList: null,
  destroyView: null
};

export const destroyReducer = createReducer<DestroyState>(
  initialState,
  on(DestroyAction.destroyRequestListResponse, (state, { response }) => {
    return { ...state, destroyRequestList: response };
  }),
  on(DestroyAction.resetDestroyRequestList, (state) => {
    return { ...state, destroyRequestList: null };
  }),
  on(DestroyAction.destroyRequestViewResponse, (state, { response }) => {
    return { ...state, destroyRequestView: response };
  }),
  on(DestroyAction.resetDestroyRequestView, (state) => {
    return { ...state, destroyRequestView: null };
  }),
  on(DestroyAction.destroyListResponse, (state, { response }) => {
    return { ...state, destroyList: response };
  }),
  on(DestroyAction.resetDestroyList, (state) => {
    return { ...state, destroyList: null };
  }),
  on(DestroyAction.destroyViewResponse, (state, { response }) => {
    return { ...state, destroyView: response };
  }),
  on(DestroyAction.resetDestroyView, (state) => {
    return { ...state, destroyView: null };
  })
);
